import { Group, Paper } from "@mantine/core";

import { isAttachment } from "../../utils";
import { AttachmentItem, FileUploadedItem } from "./components";

import type { DropdownProps } from "@/components/elements";
import type { FC } from "react";
import type { FileAttachment } from "../../types";
import type { AttachmentItemLabels, FileUploadedItemLabels } from "./components";

export type FileItemProps = {
  disabled?: boolean;
  file: FileAttachment;
  labels?: AttachmentItemLabels & FileUploadedItemLabels;
  onChange?: (file: Partial<FileAttachment>) => void;
  onDelete?: () => void;
  types?: DropdownProps["data"];
};

export const FileItem: FC<FileItemProps> = ({
  disabled = false,
  file,
  labels,
  onChange,
  onDelete,
  types,
}) => {
  return (
    <Paper px="lg" py="md" withBorder>
      <Group justify="space-between">
        {isAttachment(file) ? (
          <AttachmentItem
            {...file}
            disabled={disabled}
            onChange={onChange}
            onDelete={onDelete}
            types={types}
          />
        ) : (
          <FileUploadedItem {...file} disabled={disabled} labels={labels} onDelete={onDelete} />
        )}
      </Group>
    </Paper>
  );
};
